/* eslint-disable no-unused-vars */
import { Routes, Route } from "react-router-dom";
import { useState, useEffect, Suspense, lazy } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { createContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminDetailsActions, notiDetailsActions } from "./redux-store/store";
import { GetAdminDetailsByID, SetNotiReadStatus } from "./apiServices";

// -------------------------pages imports --------------------------------

import SideNavbar from "./components/Navbar/component/sideNavbar";
import ProfilePage from "./pages/ProfileDetails/profilePage";
import AccountDeactivationMessage from "./pages/NotFound/accountDeactivate";
import MidLevelList from "./pages/Candidate/MidLevelCandidate/MidLevelList";
import Jobs from "./pages/Tabsview/Jobs/Jobs";
import MidLevelTabsview from "./pages/Tabsview/MidLevel/MidLevelSenior";
import CandidateFunnel from "./pages/CandidateFunnel/CandidateFunnel";
import SuperAdminTableView from "./pages/Tabsview/SuperAdminTabView/SuperAdminTableView";
import AnalyticsAdmin from "./pages/Tabsview/SuperAdminAnalytics/AnalyticsAdmin";
import AdminBugFixerTab from "./pages/Tabsview/AdminBugNewFeature/AdminBugFixerTab";
import CandidatePipelineTab from "./pages/Tabsview/PiplineTabView/CandidatePipeline/CandidatePipline";
import LeadForm from "./pages/Candidate/Insta/Youtube Form/LeadForm";
import CandidateRetention from "./pages/Candidate/CandidateRetention/CandidateRetention";
import { decryptedAdminID } from "./utility";
// import WorkingFile from "./pages/workingFile";
import PieChart from "./pages/AdminDashboard/jobDetailsPie/pieChart";
import CandidateCallRemainder from "./pages/Candidate/CandidateCallRemainder/CandidateCallRemainder";
import InvoiceForm from "./pages/workingFile";
import InvoiceTableView from "./pages/Employer/invoice/TableView/InvoiceTableView";
import Document from "./pages/invoceDoc/Document";
import InvoiceITPostForm from "./pages/Employer/invoice/InvoiceITPostForm";
import TargetPostForm from "./pages/AdminDetails/ConfigarationTablesCrud/Targetanalytics/PostApi";
import TargetAnalyticsTable from "./pages/AdminDetails/ConfigarationTablesCrud/Targetanalytics/TargetAnalyticsTable";
import PipelineTab from "./pages/Tabsview/PiplineTabView/NewPipeline/PipelineTab";
import DetailContainer from "./components/CandidateDetailView/DetailContainer";
import NewFollowUp from "./pages/NewFollowUp/NewFollowUp";
import CreateFollowUp from "./pages/NewFollowUp/CreateFollowUp";
import TargetMonthly from "./pages/ProfileDetails/TargetMonthly";
// ------------------------- End ofpages imports --------------------------------

const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const EmployerTabs = lazy(() =>
  import("./pages/Tabsview/EmployerTabsView/EmployerTabs")
);
const EmployerLeadTable = lazy(() =>
  import("./pages/Employer/employerLead/EmployerLeadTable")
);
const CandidatePipeline = lazy(() =>
  import("./pages/pipelines/candidatePipeline/pipeline")
);
const LogIn = lazy(() => import("./pages/LoginPage/login"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));

const CandidateTabsview = lazy(() =>
  import("./pages/Tabsview/Candidate/CandidateTabsview")
);

export function user_details() {
  let user_obj = { isLoggedIn: false };
  return user_obj;
}

export const PageStatus = createContext();

const RoutesWrp = () => {
  const history = useLocation();
  const navigate = useNavigate();
  const Dispatch = useDispatch();

  const adminDetails = useSelector((state) => state.adminDetails);
  // console.log(adminDetails);

  let isSuperAdmin = adminDetails.roleID === 1;

  const pathname = history.pathname;
  const queryParams = new URLSearchParams(history.search);

  // Get the value of the "param" query parameter
  const paramValue = queryParams.get("notificationID");
  useEffect(() => {
    if (paramValue) {
      // alert("hii");
      // console.log(paramValue);
      SetNotiReadStatus(paramValue);
      Dispatch(notiDetailsActions.setNotiDetail(paramValue));
      Dispatch(notiDetailsActions.showDetails(paramValue));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const [activeTab, setActiveTab] = useState({
    isKyc: true,
    isDashbord: false,
  });

  useEffect(() => {
    let isDashbord = history.pathname.indexOf("/dashboard") !== -1;
    let isCandiFilter = history.pathname.indexOf("/candidate_Job") !== -1;
    let isKyc = history.pathname.indexOf("/CandidateTabsview") !== -1;
    let isEmployers = history.pathname.indexOf("/Employer_filter") !== -1;
    let isCandidate = history.pathname.indexOf("/isCandidate") !== -1;
    let isCandidateLead = history.pathname.indexOf("/Can_Lead") !== -1;
    let isAlert = history.pathname.indexOf("/isAlert") !== -1;
    let iscaninterviews = history.pathname.indexOf("/can_interview") !== -1;

    setActiveTab((val) => ({
      ...val,
      isKyc: isKyc,
      isEmployers: isEmployers,
      isDashbord: isDashbord,
      isCandiFilter: isCandiFilter,
      isCandidate: isCandidate,
      isCandidateLead: isCandidateLead,
      isAlert: isAlert,
      iscaninterviews: iscaninterviews,
    }));
  }, [history]);
  useEffect(() => {
    const adminID = decryptedAdminID();
    if (decryptedAdminID() != null) {
      Dispatch(
        adminDetailsActions.setAdminLoginDetails({
          adminID: adminID,
        })
      );
      GetAdminDetailsByID(adminID).then((data) => {
        if (data.admin.is_deactivate) {
          navigate("/AccountDeactivated");
        }
      });
      let isLogin = history.pathname.indexOf("/login") !== -1;
      isLogin && navigate("/CandidateTabsview");
    } else {
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PageStatus.Provider value={{ activeTab, setActiveTab }}>
        {adminDetails.adminID !== "" && adminDetails.adminID != null && (
          <>
            <Suspense fallback={<div>Loading...</div>}>
              <SideNavbar>
                <Routes>
                  <Route index element={<CandidateTabsview />}></Route>
                  <Route path="/Dashboard" element={<Dashboard />}></Route>
                  <Route path="*" element={<NotFound />}></Route>
                  <Route path="/" element={<LogIn />}></Route>
                  <Route
                    path="/midlevel_candidate_leads"
                    element={<MidLevelList />}
                  ></Route>
                  <Route
                    path="/superAdminAnalytics"
                    element={<AnalyticsAdmin />}
                  ></Route>
                  <Route
                    path="/AdminAnalytics"
                    element={<CandidateFunnel />}
                  ></Route>
                  {/* <Route
                    path="/Bug/NewFeature"
                    element={<AdminBugFixerTab />}
                  ></Route> */}
                  <Route
                    path="/superAdminTab"
                    element={<SuperAdminTableView />}
                  ></Route>
                  <Route
                    path="/CandidateTabsview"
                    element={<CandidateTabsview />}
                  ></Route>{" "}
                  <Route
                    path="/EmployerTabsview"
                    element={<EmployerTabs />}
                  ></Route>
                  <Route
                    path="/InvoiceTabView"
                    element={<InvoiceTableView />}
                  ></Route>
                  {/* <Route
                    path="/MidLevelSenior"
                    element={<MidLevelTabsview />}
                  ></Route> */}
                  <Route path="/JobsTabsview" element={<Jobs />}></Route>
                  <Route path="/profile_page" element={<ProfilePage />}></Route>
                  <Route path="/admin_target" element={<TargetMonthly />}></Route>
                  <Route path="/login" element={<LogIn />}></Route>
                  <Route
                    path="/AccountDeactivated"
                    element={<AccountDeactivationMessage />}
                  ></Route>
                  <Route
                    path="/CandidatePipelineTab"
                    element={<CandidatePipelineTab />}
                  ></Route>
                  <Route path="/candidate/:id" element={<DetailContainer />} />
                  <Route
                    path="/NewCandidatePipelineTab"
                    element={<PipelineTab />}
                  ></Route>
                    <Route path="/NewFollowUp" element={<NewFollowUp />}></Route>
                       <Route path="/working" element={<CreateFollowUp />}></Route>
                 
                  <Route path="/workingFile" element={<PieChart />}></Route>
                  {/* <Route
                    path="/working"
                    element={<TargetAnalyticsTable />}
                  ></Route> */}
                </Routes>
              </SideNavbar>
            </Suspense>
          </>
        )}

        {!adminDetails.adminID && (
          <>
            <Routes>
              <Route path="*" element={<NotFound />}></Route>
              <Route path="/" element={<LogIn />}></Route>
              <Route path="/login" element={<LogIn />}></Route>
            </Routes>
          </>
        )}
      </PageStatus.Provider>
    </>
  );
};

export default RoutesWrp;
